import Popper from 'popper.js';
import { v1 as uuid } from 'uuid';
// Map for the Tips
var tipsMap = new Map();
var initiatePopper = function (reference, content, placement) {
    var options = {
        placement: placement,
        modifiers: {
            preventOverflow: {
                escapeWithReference: true,
            },
        },
    };
    return new Popper(reference, content, options);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var fetchClasses = function (modifiers) {
    var classes = ['v-tooltip'];
    for (var property in modifiers) {
        if (modifiers.hasOwnProperty(property) && property.startsWith('class--')) {
            classes.push(property.replace('class--', ''));
        }
    }
    return classes;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var fetchPlacement = function (modifiers) {
    for (var property in modifiers) {
        if (modifiers.hasOwnProperty(property) && property.startsWith('placement--')) {
            return property.replace('placement--', '');
        }
    }
    return 'right';
};
/**
 * Creates a new HTMLDivElement with given content as textContent + 'pops' it into right place in viewport
 */
var enterHandler = function (tooltipTarget, id) {
    var tip = tipsMap[id];
    if (!tip || !tip.content) {
        return;
    }
    // Constructs a new div for the tip element that can be 'popped' into place by Popper
    tip.element = document.createElement('div');
    // Insert default wrapper class & append a custom class inserted via directive hook argument if one is provided
    tip.element.className = fetchClasses(tip.modifiers).join(' ');
    if (tip.argument) {
        tip.element.classList.add(tip.argument);
    }
    // See if content is a valid Node, and treat it like a Node instead of a string if so
    if (tip.content.nodeType) {
        tip.element.appendChild(tip.content);
    }
    else {
        tip.element.textContent = tip.content;
    }
    document.body.appendChild(tip.element);
    // Tooltip's visibility has to be toggled via a class,
    // so that Popper's applyStyle() modifier doesn't conflict with Vue's style calculation logic
    tip.element.classList.add('active');
    // References to both popper instance + tooltip node itself are stored in module scope,
    // for removal later in leaveHandler()
    tip.popper = initiatePopper(tooltipTarget, tip.element, fetchPlacement(tip.modifiers));
};
/**
 * Destroys the associated Popper instance + removes the tooltip created earlier from DOM via given elements id
 */
var leaveHandler = function (id) {
    var tip = tipsMap[id];
    if (!tip || !tip.content) {
        return;
    }
    // Popper instance has to be destroyed before the tooltip Element can be removed from DOM
    tip.popper.destroy();
    tip.element.remove();
};
export default {
    name: 'tooltip',
    options: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        bind: function (element, binding, vnode) {
            var tip = {
                id: uuid(),
                argument: binding.arg,
                content: binding.value,
                modifiers: binding.modifiers,
            };
            tip.enterHandler = enterHandler.bind(null, element, tip.id);
            tip.leaveHandler = leaveHandler.bind(null, tip.id);
            element.addEventListener('mouseenter', tip.enterHandler);
            element.addEventListener('mouseleave', tip.leaveHandler);
            vnode.elm.dataset.tipId = tip.id;
            tipsMap[tip.id] = tip;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        unbind: function (element, binding, vnode) {
            var _a;
            var tip = tipsMap[vnode.elm.dataset.tipId];
            if (!tip) {
                return;
            }
            element.removeEventListener('mouseenter', tip.enterHandler);
            element.removeEventListener('mouseleave', tip.leaveHandler);
            (_a = tip.element) === null || _a === void 0 ? void 0 : _a.remove();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        componentUpdated: function (element, binding, vnode) {
            var tip = tipsMap[vnode.elm.dataset.tipId];
            if (!tip) {
                return;
            }
            tip.content = binding.value;
            tip.modifiers = binding.modifiers;
            tip.argument = binding.arg;
        },
    },
};
